import { FC } from "react";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";

import TopNav from "../../components/TopNav/TopNav";
import Button from "../../components/Button/Button";
import { UpdateIcon } from "../../components/icons/UpdateIcon";
import {
  selectActivePromptsState,
  selectInactivePromptsState,
  selectLoading as selectPromptsLoading,
  selectPromptsLoadError,
} from "../../store/selectors/prompts";
import { fetchPrompts } from "../../store/prompts/slice";
import ContentLayout from "../../layout/ContentLayout/ContentLayout";
import { TitleWithForm } from "../../components";
import { addPrompt } from "../../store/prompts/slice";
import Title from "../../components/Title/Title";
import CardSwitchPromptsWrapper from "../../components/CardSwitchPromptsWrapper/CardSwitchPromptsWrapper";
import { AddFormItem } from "../../components/AddForm/types";

import styles from "./SettingPrompts.module.css";



const SettingPromptsView: FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const promptsLoading = useSelector(selectPromptsLoading);
  const promptsError = useSelector(selectPromptsLoadError);
  const activePrompts = useSelector(selectActivePromptsState);
  const inactivePrompts = useSelector(selectInactivePromptsState);

  const renderTopNavRightContent = () => {
    return (
      <div className={styles["modal"]}>
        <p className={styles["modal__changed"]}><UpdateIcon /> changes saved</p>
        <Button label="Close" onClick={closePromptsSettings} />
      </div>
    );
  };

  const closePromptsSettings = () => {
    navigate(-1);
  };

  const handleAddPrompt = (item: AddFormItem) => {
    dispatch(addPrompt({ content: item.label }));
  };



  return (
    <>
      <TopNav title="Prompts Settings" rightContent={renderTopNavRightContent()} />
      <ContentLayout>
        <TitleWithForm
          className={styles["title-add"]}
          label="Active Prompts"
          onAddItem={handleAddPrompt}
          placeholder="Add a new prompt"
        />

        <CardSwitchPromptsWrapper
          prompts={activePrompts}
          active={true}
          skeletonCount={3}
          loading={promptsLoading}
          error={promptsError}
          onRetry={() => dispatch(fetchPrompts())}
        />

        {inactivePrompts && inactivePrompts.length > 0 && <Title className={styles["title"]} label="Inactive Prompts" />}
        <CardSwitchPromptsWrapper
          prompts={inactivePrompts}
          active={false}
          skeletonCount={3}
          loading={promptsLoading}
          error={promptsError}
          onRetry={() => dispatch(fetchPrompts())}
        />
      </ContentLayout>
    </>
  );
}

export default SettingPromptsView;
